import React from "react";
import { PropTypes } from "prop-types";
import { LinkSimple } from "../../_atoms/_link-simple/LinkSimple.js";
export const CardProductClaim = ({ title, subtitle, desc, button, link }) => {
  return (
    <>
      <div className="card-product-claim">
        <span className="h3">{title}</span>
        <span className="h4">{subtitle}</span>
        <p>{desc}</p>
        {link && (
          <LinkSimple href="{link}" css="link-simple--1">
            {button}
            <svg className="icon icon--sm" role="presentation">
              <use xlinkHref="./svg/sprite.svg#arrow-right"></use>
            </svg>
          </LinkSimple>
        )}
      </div>
    </>
  );
};

CardProductClaim.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};
